module.exports = __webpack_public_path__ + "static/media/east_africans_icon_medium.68c38671.png";